<template>
  <RelatedPromptsTagList
    button-class="x-button-lead x-button-circle x-button-ghost x-p-0"
    class="x-mt-0 x-h-[140px] x-p-0 x-text-neutral-50"
    :tag-class="tagClass"
    :tag-colors="['x-bg-neutral-0']"
  >
    <template #sliding-panel-left-button>
      <ChevronLeftIcon class="x-icon-lg" />
    </template>
    <template #default="{ relatedPrompt, isSelected, onSelect }">
      <DisplayEmitter
        :payload="relatedPrompt.tagging.toolingDisplayTagging"
        :event-metadata="{
          feature: 'related_prompts',
          displayOriginalQuery: x.query.searchBox,
          replaceable: false,
        }"
      >
        <RelatedPrompt
          :related-prompt="relatedPrompt"
          :selected="isSelected"
          data-wysiwyg="related-prompt"
          class="x-rounded-md x-text-neutral-100"
          :data-wysiwyg-id="relatedPrompt.suggestionText"
          @click="onSelect"
        >
          <template #related-prompt-extra-content>
            <LightBulbIcon
              v-if="!isSelected && isDesktopOrGreater"
              class="x-related-prompt-image"
            />
          </template>
        </RelatedPrompt>
      </DisplayEmitter>
    </template>
    <template #sliding-panel-right-button>
      <ChevronRightIcon class="x-icon-lg" />
    </template>
  </RelatedPromptsTagList>
</template>

<script setup lang="ts">
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  DisplayEmitter,
  use$x,
  useState,
} from '@empathyco/x-components'
import { RelatedPrompt, RelatedPromptsTagList } from '@empathyco/x-components/related-prompts'
import { computed } from 'vue'
import { useDevice } from '../../composables/use-device.composable'
import LightBulbIcon from '../icons/light-bulb-icon.vue'

const { isDesktopOrGreater } = useDevice()
const { selectedPrompt } = useState('relatedPrompts')
const tagClass = computed(() =>
  selectedPrompt.value !== -1
    ? 'x-rounded-t-md x-gap-8 x-w-[300px] x-border-b-0 x-border x-border-lead-75 x-pt-24'
    : 'x-rounded-md x-gap-8 x-w-[300px] !x-h-128 x-p-8 x-border x-border-lead-75',
)
const x = use$x()
</script>

<style>
.x-related-prompt {
  display: flex;
  gap: 12px;
}
.x-related-prompt-image {
  align-self: start;
}
.x-related-prompt-text {
  align-self: start;
}
.x-related-prompt-text--selected {
  text-align: left !important;
  margin-left: 8px;
}
</style>
